import {WaPackage} from "../../utils/types/AiTypes";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {API_WA_PACKAGE_LIST_ENDPOINT} from "../../utils/constants";

export interface WaPackageState {
    waPackages: WaPackage[];
    status: "fulfilled" | "pending" | "rejected" | "idle";
}

const initialState: WaPackageState = {
    waPackages: [],
    status: "idle"
}

export const fetchAllWaPackages = createAsyncThunk(
    "waPkgs/fetchAllWaPackages",
    async (params: {keycloak: Keycloak.KeycloakInstance}): Promise<WaPackage[]> => {
        const {keycloak} = params;
        const res = await axios.get(`${API_WA_PACKAGE_LIST_ENDPOINT}`, {
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${keycloak?.token}`,
            },
            withCredentials: true,
        });
        return res.data;
    }
);

export const WaPackageSlice = createSlice({
    name: 'WaPackages',
    initialState,
    reducers: {
        getWaPackages: (state, action) => {
            state.status = 'fulfilled';
            state.waPackages = action.payload.data;
        },
        failedToGetWaPackages: (state) => {
            state.status = 'rejected';
            state = initialState
        },
        resetWaPackagesState: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllWaPackages.fulfilled, (state, action) => {
            state.status = "fulfilled";
            state.waPackages = action.payload;
        })
    }
});

export const { getWaPackages, failedToGetWaPackages,resetWaPackagesState} = WaPackageSlice.actions;
export default WaPackageSlice.reducer;